import { useQuery } from "react-query";
import { getIOGroupData } from "@/api/Histories/io-api";

const key = "io-group";

export function useIOGroup(outputCode, balanceId, options = {}) {
	return useQuery([key, outputCode, balanceId], () => getIOGroupData(outputCode, balanceId), {
		enabled: Boolean(outputCode) && Boolean(balanceId),
		staleTime: 0,
		...options,
	});
}
